// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart-box-list[data-v-2e2ddf70]{margin-bottom:.8rem}.epanel[data-v-2e2ddf70]{border-bottom:none}", ""]);
// Exports
module.exports = exports;
